<div class="module-wrapper content-wrapper" *ngIf="roleSer.accessData && roleSer.accessData.rolesAssigned === accountAdmin">
  <div class="tab-container">
    <mat-card>
      <mat-card-content>
        <div class="head-container">
          <div class="pageTitle">
            <h1>{{'collectionById.heading' | translate}}</h1>
            <!-- <div (mouseover)="onTraningIcon(videoAssetGroups.manageCollectiondetails)">
              <img class="trainingIcon" src="../../../assets/favicon/video.png">
            </div>

            <div class="popupHover">
              <ng-container *ngIf="isHidden">
                <div class="hideshow">
                  <a *ngFor="let links of videoLinks" (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', links.assetUrl);">{{links.assetShortName}} <br></a>
                </div>
              </ng-container>
            </div> -->
          </div>
          <div class="bread-crumb">
            <div class="breadcrumb-container">
              <a [routerLink]="[]" class="link-active" (click)="navigatetoCollection()">{{'collectionById.nav1' | translate}}</a> /
              <span class="nav-link" *ngIf="tab1">{{tab}}</span>
              <span class="nav-link" *ngIf="!tab1">{{'collectionById.nav2' | translate}}</span>
            </div>
          </div>
        </div>
        <div class="item-info-container">
          <div class="itemdetail">
            <div class="item-name"><span>{{'collectionById.labelName' | translate}}: {{collectionNameDisplay}}</span> </div>
            <div class="item-desc">{{'collectionById.labelDesc' | translate}}: {{collectionDescriptionDisplay}} </div>
          </div>

          <span class="spacer"></span>
          <div class="edit-btn-wrapper">
            <div class="btn-wrapper">
              <button mat-icon-button aria-label="Edit Collection" matTooltip="{{'collectionById.edit' | translate}}" matTooltipPosition="above"
                [disabled]="roleSer.accessData && roleSer.accessData?!roleSer.accessData.updateAllowed :true" (click)="openEditCollectionDialog()"
                class="edit"><span class="menu-icon"><i-feather name="edit"></i-feather></span></button>
            </div>
          </div>
        </div>
        <mat-tab-group mat-align-tabs="end" (selectedTabChange)="onChange($event)"
        [selectedIndex]="selectedTabIndex" animationDuration="0ms">
          <!-- <mat-tab>
          <ng-template mat-tab-label>
            <span class="menu-icon"><i-feather name="help-circle"></i-feather></span>
            <span>Details</span>
          </ng-template>
        </mat-tab> -->
          <mat-tab label="{{'collectionById.tab1' | translate}}">
            <ng-template mat-tab-label>
              <span class="menu-icon"><i-feather name="User"></i-feather></span>
              <span>{{'collectionById.userIcon' | translate}}</span>
            </ng-template>
            <div class="tab-content" *ngIf="selectedTabIndex == 0">
              <app-collection-users></app-collection-users>
            </div>
          </mat-tab>
          <mat-tab label="{{'collectionById.tab2' | translate}}">
            <ng-template mat-tab-label>
              <span>{{'collectionById.styleGroup' | translate}}</span>
            </ng-template>
            <div class="tab-content" *ngIf="selectedTabIndex == 1">
              <app-collection-style-groups></app-collection-style-groups>
            </div>
          </mat-tab>
          <!-- <mat-tab label="License" disabled>
          <ng-template mat-tab-label>
            <span class="menu-icon"><i-feather name="Key"></i-feather></span>
            <span>License</span>
         </ng-template>
          <div class="tab-content">

          </div>
        </mat-tab>
        <mat-tab label="Other options" disabled>
          <ng-template mat-tab-label> -->
          <!-- <span class="menu-icon"><i-feather name="help-circle"></i-feather></span> -->
          <!-- <span class="menu-icon"><mat-icon>compare_arrows</mat-icon></span>
            <span>Other options</span>
         </ng-template>
          <div class="tab-content">

          </div>
        </mat-tab> -->
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
  </div>
</div>









<!-- <div class=" main-content-wrapper edit-collection">
  <div class="content-wrapper">
    <div class="filter-section">
      <button class="btn-back" mat-raised-button mat-flat-button color="basic" (click)="navigatetoCollection()">
                                                <i class="fa fa-angle-left"></i>
                                                <span>Back</span>
                                            </button>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="tabs">
          <span class="collection-name">Collection name : {{collectionNameDisplay}}</span>
          <mat-tab-group mat-align-tabs="end" animationDuration="0ms">
            <mat-tab label="Details">
              <div class="col-md-12">
                <div class="registration-form">
                  <form [formGroup]="userForm">
                    <div class="form-input save-btn">
                      <button mat-flat-button class="btn-bg-color" [disabled]="userForm.invalid" (click)="saveBtnFn()"> Save</button>
                    </div>
                    <div class="input-class">
                      <label>Collection name<span class="red-asterisk"> *</span></label>
                      <input type="text" maxlength="121" class="form-control" placeholder="" formControlName="collectionName">
                      <div *ngIf="f.collectionName.invalid && (f.collectionName.dirty || f.collectionName.touched)"
                        class="alert alert-danger">
                        <div *ngIf="f.collectionName.errors?.required"> Collection name is required.</div>
                        <div *ngIf="f.collectionName.errors?.minlength"> Minimum 3 characters required.</div>
                        <div *ngIf="f.collectionName.errors?.maxlength"> Maximum 120 characters allowed.</div>
                      </div>
                    </div>
                    <div class="input-class">
                      <label>Collection description</label>
                      <textarea  type="text" maxlength="481" class="form-control textarea"  placeholder="" formControlName="description"></textarea>
                      <div *ngIf="f.description.invalid && (f.description.dirty || f.description.touched)" class="alert alert-danger">
                        <div *ngIf="f.description.errors?.minlength"> Minimum 20 characters required.</div>
                        <div *ngIf="f.description.errors?.maxlength"> Maximum 480 characters allowed.</div>
                      </div>
                    </div>
                    <div class="input-class">
                      <label>Language<span class="red-asterisk"> *</span></label>
                      <select  type="text" class="form-control" name="language" [(value)]="selectedLanguage" formControlName="langid">
                        <option *ngFor="let option of languageArr" [value]="option?.langId">
                          {{option?.language}}
                        </option>
                      </select>
                      <div *ngIf="f.langid.invalid && (f.langid.dirty || f.langid.touched)" class="alert alert-danger">
                        <div *ngIf="f.langid.errors?.required"> Language is required. </div>
                      </div>
                    </div>
                    <div class="input-class">
                      <label>Time zone<span class="red-asterisk"> *</span></label>
                      <select  type="text" class="form-control" name="timezone" [(value)]="timeZone" formControlName="timezoneid">
                        <option *ngFor="let option of timeZoneArr" [value]="option?.timezoneid">
                          {{option?.standardname}}
                        </option>
                      </select>
                      <div *ngIf="f.timezoneid.invalid && (f.timezoneid.dirty || f.timezoneid.touched)" class="alert alert-danger">
                        <div *ngIf="f.timezoneid.errors?.required"> Time zone is required. </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </mat-tab>
            <mat-tab label="Users">
                <app-collection-users></app-collection-users>
            </mat-tab>

            <mat-tab label="License">

            </mat-tab>
            <mat-tab label="Other options">

            </mat-tab>
          </mat-tab-group>
        </div>
      </div>

    </div>
  </div> -->
